import axios from '../utils/axios';

const API_URL = process.env.REACT_APP_API_URL + '/v1/client';

const getSmsTemplates = (clinicId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/sms-templates`);
};

const getSmsTemplateById = (clinicId, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/sms-templates/${templateId}`);
};

const updateSmsTemplate = (clinicId, templateId, data) => {
    return axios.put(`${API_URL}/clinics/${clinicId}/sms-templates/${templateId}`, data);
};

const getEmailTemplates = (clinicId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/email-templates`);
};

const getEmailTemplateById = (clinicId, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/email-templates/${templateId}`);
};

const updateEmailTemplate = (clinicId, templateId, data) => {
    return axios.put(`${API_URL}/clinics/${clinicId}/email-templates/${templateId}`, data);
};

const getCallTemplates = (clinicId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/call-templates`);
};

const getCallTemplateById = (clinicId, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/call-templates/${templateId}`);
};

const updateCallTemplate = (clinicId, templateId, data) => {
    return axios.put(`${API_URL}/clinics/${clinicId}/call-templates/${templateId}`, data);
};

const getCallAudioPlay = (clinicId, templateId) => {
    return axios.get(`${API_URL}/clinics/${clinicId}/call-templates/${templateId}/play-audio`, {
        responseType: 'arraybuffer',
    });
};

const templatesService = {
    getSmsTemplates,
    getSmsTemplateById,
    updateSmsTemplate,
    getEmailTemplates,
    getEmailTemplateById,
    updateEmailTemplate,
    getCallTemplates,
    getCallTemplateById,
    updateCallTemplate,
    getCallAudioPlay,
};

export default templatesService;
